import { ApiKey, BaseUrl } from '../global'
import axios from 'axios'

export const save = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/booking/Save', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const bulkSave = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/booking/DarazBulkSave', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const BulkMapICCID = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/booking/BulkMapICCIDSave', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const retailBulkSave = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/booking/RetailBulkSave', data, {
            headers: {
                key: ApiKey,
    }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const saveReversePickup = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/booking/reversepickup', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const reverseCNInfo = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/booking/ReverseCNInfo', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e.toString() };
    }
}

export const voidCNs = async (cns) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/booking/VoidCNs', cns, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const getServiceGuide = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/booking/GetServiceGuide', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const getCustomerInfo = async (phoneNo, accountNo) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/booking/GetCustomerInfo?phoneno=' + phoneNo + '&accountNo=' + accountNo, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}


export const getTarrif = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/booking/gettariff', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}


export const getAccountBranches = async (account) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/Booking/GetAccountBranches' + `?account=${account}`, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e }
    }
}
